export default "__VITE_ASSET__DQJSky$F__"